import {AbstractModel} from "./abstract-model";
import {UploadFile} from './upload-file';

export class ComplianceUploadFile extends AbstractModel {

  id: number | null = null;
  document: UploadFile = new UploadFile();

  isEmpty(): boolean {
    return this.document.isEmpty();
  }

  getData(type: string): any {
    const data: any = {
      type,
    };

    if (!this.document.isEmpty()) {
      data.document = this.document;
    }

    return data;
  }
}
